import PropTypes from 'prop-types'
import moment from 'moment'
import BeamIcon from 'beam/dist/BeamIcon'
import IconButton from 'beam/dist/IconButton'
import Typography from 'beam/dist/Typography'
import withStyles from 'beam/dist/styles'
import { DropdownListItem, DropdownListItemText, DropdownListItemSecondaryAction } from '../NavBar/Dropdown'

const styles = theme => ({
  unreadAlert: {
    fontWeight: 'bold',
  },
  readAlert: {
    fontWeight: 'inherit',
  },
  closeButton: {
    height: theme.spacing(3),
    width: theme.spacing(3),
  },
  listItemText: {
    paddingRight: theme.spacing(4),
  },
  secondaryAction: {
    right: theme.spacing(0.5),
  },
})

const UnreadAlert = ({ text, className }) => (
  <Typography variant="body2" className={className} color="secondary">
    {text}
  </Typography>
)

UnreadAlert.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
}

const ReadAlert = ({ text, className }) => (
  <Typography variant="body2" className={className}>
    {text}
  </Typography>
)

ReadAlert.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
}

const Alert = ({ text, timestamp, unread, onClick, onDelete, onMouseEnter, onMouseLeave, showDeleteIcon, classes }) => (
  <DropdownListItem onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} button>
    <DropdownListItemText className={classes.listItemText}>
      {unread ? (
        <UnreadAlert text={text} className={classes.unreadAlert} />
      ) : (
        <ReadAlert text={text} className={classes.readAlert} />
      )}
      <Typography variant="caption" gutterBottom>
        {moment(timestamp).format('MM/DD/YYYY') /* TODO: timezones will be addressed in a separate story */}
      </Typography>
    </DropdownListItemText>
    <DropdownListItemSecondaryAction className={classes.secondaryAction}>
      <IconButton
        className={classes.closeButton}
        onClick={event => {
          event.stopPropagation()
          onDelete()
        }}
      >
        {showDeleteIcon && <BeamIcon>Delete</BeamIcon>}
      </IconButton>
    </DropdownListItemSecondaryAction>
  </DropdownListItem>
)

Alert.propTypes = {
  text: PropTypes.string.isRequired,
  timestamp: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  showDeleteIcon: PropTypes.bool,
  unread: PropTypes.bool,
}

Alert.defaultProps = {
  showDeleteIcon: false,
  unread: false,
}

export default withStyles(styles)(Alert)
